module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "radio-box",
    class: {
      'active': _vm.isActive
    },
    attrs: {
      "for": _vm.labelFor
    }
  }, [_c('div', {
    staticClass: "circle-container"
  }, [_c('div', {
    staticClass: "circle",
    style: (("background-color: " + _vm.color))
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.shortText) + "\n\t\t\t")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t")]), _vm._v(" "), _c('input', {
    attrs: {
      "hidden": "",
      "id": _vm.labelFor,
      "type": "radio",
      "name": "type"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2439e37d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RadioKeeping.vue
// module id = 1601
// module chunks = 6